import ApiService from '@/services/core/api.service'

const OrganizationService = {
  async get (query) {
    return ApiService.get(`admin/organizations?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/organizations', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/organizations/${payload.id}`, payload)
  }
}

export default OrganizationService
